import { defineAsyncComponent } from 'vue';

export default {
	forms: {
		list: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {}
				}
			},
			component: defineAsyncComponent(() => import('./forms/List.vue'))
		},
		select: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {
					}
				}
			}
		},
		edit: {
			config: {
				fields: {
					id: {
						config: {
							visible: false
						}
					},
					name: {
					}
				}
			},
			component: defineAsyncComponent(() => import('./forms/Edit.vue'))
		}
	}
}